import { Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import Ekomi from './Ekomi'
import { TuevCertificate as TuevCertificateTooltip } from './Tooltip/TuevCertificate'
import { TuevCertificate as TuevCertificateModal } from './Modal/TuevCertificate'
import { TopZinsGarantie as TopZinsGarantieTooltip } from './Tooltip/TopZinsGarantie'
import { TopZinsGarantie as TopZinsGarantieModal } from './Modal/TopZinsGarantie'

const StyledGrid = styled(Grid)({
  margin: '0 auto',
  width: '100%'
})

interface Props {
  isEkomiHidden?: boolean
  tuevOrder?: number
}

export const TrustCards = ({ isEkomiHidden, tuevOrder }: Props) => {
  return (
    <StyledGrid
      container
      direction="row"
      alignItems="center"
      justifyContent="space-around"
      spacing={0.5}
    >
      {!isEkomiHidden && (
        <Grid item>
          <Ekomi />
        </Grid>
      )}
      <Grid item order={tuevOrder} display={{ xs: 'flex', sm: 'none' }}>
        <TuevCertificateModal />
      </Grid>
      <Grid item display={{ xs: 'flex', sm: 'none' }}>
        <TopZinsGarantieModal />
      </Grid>
      <Grid item order={tuevOrder} display={{ xs: 'none', sm: 'flex' }}>
        <TuevCertificateTooltip />
      </Grid>

      <Grid item xs={0} sm={5} display={{ xs: 'none', sm: 'flex' }}>
        <TopZinsGarantieTooltip />
      </Grid>
    </StyledGrid>
  )
}
